import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class Warranty extends BaseModel {
  static override constructorName = 'Warranty'

  public color: string = '#fff'
  public icon: string = ''
  public text: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.icon = toCroppedImage(data.icon)
    }
  }
}
